import Navbar from './Navbar';
import Loader from './Loader';

const Layout = ({ children }) => {
    return (
        <>
            <Navbar />
            <Loader />
            <div className="container-fluid pt-3" style={{ background: '#111111', minHeight: 'calc(100vh - 75px)', color: '#F0F0F0' }}>
                {children}
            </div>
        </>
    );
};

export default Layout;
